import React from "react"
import camelCase from "lodash/camelCase"
import { getDisplayedImage, mapColumnSize } from "src/legacy/utils"

import AppStoreButtons from "legacy/components/shared/AppStoreButtons"
import Buttons from "./Buttons"
import { Element } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import HeroText from "./HeroText"
import { HeroType } from "types/shared-components"
import HeroImage from "./HeroImage"
import { Maybe } from "types/Maybe"
import useBreakpoints from "src/legacy/hooks/useBreakpoints"

interface OwnProps {
  data: Maybe<HeroType>
}

export type HeroProps = OwnProps

const Hero: React.FC<HeroProps> = ({ data }): React.ReactElement | null => {
  if (!data?.primary) return null

  const { primary, items } = data
  const { breakpoint } = useBreakpoints()
  const {
    app_store_buttons,
    background_color,
    font_color,
    hero_width,
    hero_width_mobile,
    image_should_be_background,
    image,
    mobile_image,
  } = primary

  const imageData = getDisplayedImage(breakpoint, image, mobile_image) || {}

  const bgColor = background_color ? camelCase(background_color) : "white"
  const bgImage =
    image_should_be_background && imageData?.url
      ? `url("${imageData.url}")`
      : null
  const mobileColumnSize = hero_width_mobile
    ? mapColumnSize(hero_width_mobile)
    : mapColumnSize(hero_width)
  const columnSize = mapColumnSize(hero_width)
  const hasButtons = typeof items?.[0] !== "undefined"
  const yPadding = image_should_be_background
    ? ["60", "110", "200"]
    : ["45", "85"]
  const textMargin = hasButtons ? ["45", "50"] : 0
  const { height, width } = imageData?.dimensions || {}

  return (
    <Element
      background={bgImage}
      backgroundPosition="top right"
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      bg={bgColor}
      px="20"
      py={yPadding}
    >
      <Grid gridTemplateColumns="1col">
        <Element
          gridColumnEnd={[
            mobileColumnSize.gridColumnEnd,
            columnSize.gridColumnEnd,
          ]}
          gridColumnStart={[
            mobileColumnSize.gridColumnStart,
            columnSize.gridColumnStart,
          ]}
          textAlign="center"
        >
          <HeroText data={primary} mb={textMargin} textColor={font_color}>
            {!image_should_be_background ? (
              <HeroImage
                aspectRatio={`${width} / ${height}`}
                imgAlt={imageData?.alt}
                imgUrl={imageData?.url}
                width={["496px", "655px", "814px", "944px"]}
              />
            ) : null}
          </HeroText>
          {hasButtons && !app_store_buttons ? <Buttons data={items} /> : null}
          {app_store_buttons ? (
            <Element display="flex" justifyContent="center" mt="50">
              <AppStoreButtons
                desktopAlignment="center"
                mobileAlignment="center"
                useQRCode={true}
              />
            </Element>
          ) : null}
        </Element>
      </Grid>
    </Element>
  )
}

export default Hero
